import { Stack } from '@mui/material';
import { UploadFilesList } from '../UploadFilesList';
import { IFormMetaData } from 'API';

interface IStep1 {
  formMetaData: IFormMetaData | undefined;
}

export const Step1 = ({ formMetaData }: IStep1) => {
  return (
    <Stack alignItems={'center'} color={'text.secondary'} gap={'8px'}>
      <UploadFilesList formMetaData={formMetaData} />
    </Stack>
  );
};
